import { render, staticRenderFns } from "./UnitsList.vue?vue&type=template&id=15ad1241&scoped=true&"
import script from "./UnitsList.vue?vue&type=script&lang=js&"
export * from "./UnitsList.vue?vue&type=script&lang=js&"
import style0 from "./UnitsList.vue?vue&type=style&index=0&id=15ad1241&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad1241",
  null
  
)

export default component.exports